import {FC, useContext, useEffect, useState} from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Grid, useMediaQuery } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import {KYCTabStyle} from "../Styles/ProfilePagesStyles";
import KYCFrame from "../SubComponents/KYCFrame";
import AuthContext from "../../store/Auth/AuthContext";
import CountryModal from "./CountryModal";
import WalletContext from "../../store/Wallet/WalletContext";
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";
import { useHistory } from "react-router";

const IdentityVerificationTab:FC = () => {
  const classes = KYCTabStyle();
  const history = useHistory();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  const { getProfileData } = useContext<any>(AuthContext);
  const { hasKycWallet } = useContext<any>(WalletContext);
  const { lockedGains } = useContext<any>(SubscriptionContext);
  const [showCountryModal, setShowCountryModal] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);

  useEffect(() => {
    // We need to ensure that user profile is fetched else button should be disabled
    if (lockedGains < 250) { 
      setDisabled(true);
      return;
    }
    if (getProfileData) {
      if (getProfileData.kycStatus) {
        if (getProfileData.kycStatus === 'approved') {
          if (hasKycWallet) {
            setDisabled(true);
          } else {
            setDisabled(false);
          }
        } else if (getProfileData.kycStatus === 'rejected') {
          setDisabled(false);
        } else {
          setDisabled(true);
        }
      } else {
        setDisabled(false)
      }
    } else {
      setDisabled(true)
    }
  },  [getProfileData, hasKycWallet, lockedGains])

  const handleClick = (event: any) => {
    event.preventDefault();
    setShowCountryModal(true);
  }

  const handleRedirect = (event: any) => {
    event.preventDefault();
    history.push('/gains'); 
  }
  
  return (
    <Box className={classes.root} mt={isActive ? 3 : 5}>
      <Grid>
        <Grid item md={7}>
          <Box display="flex" alignItems="center" mb={1}>
            <Typography variant="h3" color="secondary">
              Identity Verification
            </Typography>
          </Box>
          {
            lockedGains < 250
            ?
              <Typography
                className="text-darkslate"
                variant="body1"
                color="primary"
              >
                To complete the KYC, please ensure you've <span style={{ borderBottom: '1px dotted #000', textDecoration: 'none', cursor: 'pointer' }} onClick={handleRedirect}>staked at least <span className="fw-bold">250 GAINS</span></span>.
              </Typography>
            :            
              <Typography
                className="text-darkslate"
                variant="body1"
                color="primary"
              >
                Your KYC ( Know your Customer ) Status <KYCFrame />
              </Typography>
          }
          <Button
            variant="contained" 
            color="secondary" 
            size="large"
            disabled={disabled}
            onClick={(e) => handleClick(e)}
          >
            {
              getProfileData && getProfileData.kycStatus
                  ? getProfileData.kycStatus === 'approved'
                    ? hasKycWallet
                      ? 'KYC Verified'
                      : 'Verify wallet'
                    : getProfileData.kycStatus === 'rejected'
                      ? 'Update Documents'
                      : getProfileData?.kycStatus === 'blocked'
                        ? 'Contact Support'
                        : 'Pending KYC Review..'
              : 'Pass KYC Now'
            }
          </Button>
        </Grid>
      </Grid>
      {
        showCountryModal && (
          <CountryModal open={showCountryModal} handleClose={() => setShowCountryModal(false)} refId={getProfileData?.id} email={getProfileData?.email} />
        )
      }
    </Box>
  );
};

export default IdentityVerificationTab;
